import { useState } from "react";
import { validatePassword } from "@/lib/password";


function SetPassword({
  updatePassword,
}: {
  /** パスワード更新コールバック。成功時は undefined、失敗時はユーザー向けエラーメッセージ文字列を返す。 */
  updatePassword: (password: string) => Promise<string | undefined>;
}) {
  const [password, setPassword] = useState("");
  const [state, setState] = useState("");
  const [checkPassword, setCheckPassword] = useState("");
  const [err, setErr] = useState("");
  const handleSetpassword = async (): Promise<boolean> => {
    if (!password) {
      setErr("パスワードを入力してください。");
      return false
    }
    if (password !== checkPassword) {
      setErr("パスワードが一致しません。");
      return false
    }
    // パスワード強度は共通仕様（8文字以上 + 英字 + 数字）でチェック
    const validationError = validatePassword(password);
    if (validationError) {
      setErr(validationError);
      return false
    }
    const error = await updatePassword(password)
    if (error) {
      setErr(error)
      return false
    }
    return true
  };
  return (
    <section className="mt-32 mx-auto w-fit">
      <div className="bg-white p-8 rounded-xl shadow-lg">
        <h1 className="text-3xl">
          <span>パスワード設定</span>
        </h1>
        <p className="text-lg mb-2">パスワードを設定してください（8文字以上英数字）。</p>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (state !== "") return;
            setState("on");
            try {
              const success = await handleSetpassword();
              // 失敗時は送信ボタンを再度有効化（成功時は遷移するため "on" のまま）
              if (!success) {
                setState("");
              }
            } catch (error) {
              console.error("パスワード設定処理でエラー:", error);
              setErr("パスワードの設定に失敗しました。再度お試しください。");
              setState("");
            }
          }}
          className="grid grid-cols-5 gap-4"
        >
          <div className="col-span-2 py-4">
            <label htmlFor="password">パスワード</label>
          </div>
          <div className="col-span-3 flex items-center">
            <input
              type="password"
              id="password"
              className="w-full px-4 py-2 border border-gray-300 rounded-md placeholder:font-light"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="col-span-2 py-4">
            <label htmlFor="password">パスワード（確認）</label>
          </div>
          <div className="col-span-3 flex items-center">
            <input
              type="password"
              id="passwordCheck"
              className="w-full px-4 py-2 border border-gray-300 rounded-md placeholder:font-light"
              onChange={(e) => setCheckPassword(e.target.value)}
            />
          </div>
          <div className="flex flex-col items-center justify-center col-span-5">
            {err && <p className="text-red-600 my-4">{err}</p>}
            <button
              type="submit"
              className="text-lg px-24 py-3"
              disabled={state !== ""}
            >
              設定する
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default SetPassword;
